import styled from '@emotion/styled';
import { Star } from '@mui/icons-material';
import { Box } from '@mui/material';

export const ReviewBox = styled(Box)({
	padding: '16px',
});
export const CustomStar = styled(Star)({
	color: '#faaf00',
	marginRight: '4px',
});
